/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_SyncingInputs */

const en_ui_integration_status_syncing = /** @type {(inputs: Ui_Integration_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing…`)
};

const de_ui_integration_status_syncing = /** @type {(inputs: Ui_Integration_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird synchronisiert…`)
};

/**
* | output |
* | --- |
* | "Syncing…" |
*
* @param {Ui_Integration_Status_SyncingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_syncing = /** @type {((inputs?: Ui_Integration_Status_SyncingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_SyncingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_syncing(inputs)
	return de_ui_integration_status_syncing(inputs)
});